
export const MODEL_NAME__SCHOOL = 'School';
export const MODEL_NAME__SCHOOL_PLURAL = 'Schools';
